import { HttpClient, HttpParams } from '@angular/common/http';
import { HttpClientBaseService } from './base/httpClientBase.service';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IServiceBase } from './base/IServiceBase';
import { A3LEmployee } from '../models/a3LEmployee.model';
import { PageList } from '../models/pageList.model';
import { A3LEmployeeAbsenteeismBase } from '../models/a3LEmployeeAbsenteeismBase.model';
import { A3LEmployeeVariableConcept } from '../models/a3LEmployeeVariableConcept.model';
import { A3LEmployeeAdvance } from '../models/a3LEmployeeAdvance.model';
import { A3LEmployeeAdvanceCreateRequest } from '../models/a3lEmployeeAdvanceCreateRequest.model';
import { A3LEmployeeExtraPay } from '../models/a3LEmployeeExtraPayment.model';
import { A3lEmployeeHolidaysTypeCalcTemplateValue } from '../models/a3LEmployeeHolidaysTypeCalcTemplateValue.model';
import { A3LEmployeeCustomDataUpdateRequest } from '../models/a3LEmployeeCustomDataUpdateRequest.model';
import { A3LEmployeeOnITModel } from '../models/a3LEmployeeOnIT.model';
import { EmpleadosSustitucionesModel } from '../models/empleadosParaSustitucion.model';
import { A3LEmployeeHiringDates } from '../models/a3LEmployeeHiringDates.model';
import { A3LEmployeeIdentificationData } from '../models/a3LEmployeeIdentificationData.model';
import { A3LEmployeeHighestCode } from '../models/a3LEmployeeHighestCode.model';
import { A3LEmployeeCreateRequest } from '../models/a3LEmployeeCreateRequest.model';
import { A3LEmployeeIdentificationDataUpdateRequest } from '../models/a3LEmployeeIdentificationDataUpdateRequest.model';
import { EEntityMode } from '../Enums/EEntityMode.enum';

@Injectable()
export class A3LEmployeeService extends HttpClientBaseService implements IServiceBase<A3LEmployee> {

  constructor(_http: HttpClient) {
    super(_http, 'Companies/', 'Employees', true);
  }

  getAllModels(companyCode?: any, params?: HttpParams): Observable<A3LEmployee[]> {
    return this.getAll(companyCode);
  }

  getPagedModels(companyCode?: any, params?: HttpParams): Observable<PageList<A3LEmployee>> {
    return this.getAll(companyCode, params);
  }

  getModel(id: any, parentId?: any): Observable<A3LEmployee> {
    return this.getSingle(id);
  }

  getAllForSelect(companyCode: string):Observable<A3LEmployee[]>{
    return this.get(`${this.getUrl(null, companyCode)}/forSelect`)
  }

  getForSubstitution(companyCode: string):Observable<EmpleadosSustitucionesModel>{
    return this.get(`${this.getUrl(null, companyCode)}/forSubstitution`)
  }

  employeeExists(companyCode: string, nif: string): Observable<boolean> {
    return this.get<boolean>(`${this.getUrl(null, companyCode)}/employeeExists/${nif}`)
  }

  checkHighestEmployeeCode(companyCode: number, tipoTrabajador: string): Observable<A3LEmployeeHighestCode> {
    return this.get<A3LEmployeeHighestCode>(`${this.getUrl(null, companyCode)}/highestEmployeeCode/${tipoTrabajador}`)
  }

  getAllOnIt(companyCode: string):Observable<A3LEmployeeOnITModel[]>{
    return this.get(`${this.getUrl(null, companyCode)}/onIt`)
  }

  getHolidays(companyCode: string, employeeCode: string, year: number): Observable<PageList<A3LEmployeeAbsenteeismBase>>{
    return this.get(`${this.getUrl(employeeCode, companyCode)}/holidays/year/${year}`)
  }

  getEmployeeVariableConcepts(companyCode: string, employeeCode: string, year: number): Observable<PageList<A3LEmployeeVariableConcept>>{
    return this.get(`${this.getUrl(employeeCode, companyCode)}/VariableConcepts/year/${year}`)
  }

  getAdvances(companyCode: string, employeeCode: string): Observable<A3LEmployeeAdvance[]>{
    return this.get(`${this.getUrl(employeeCode, companyCode)}/advances`);
  }

  addAnAdvance(companyCode: string, employeeCode: string, advance: A3LEmployeeAdvanceCreateRequest): any{
    return this.http.post<A3LEmployeeAdvanceCreateRequest>(`${this.getUrl(employeeCode, companyCode)}/advances`, advance);
  }

  getExtraPayments(companyCode: string, employeeCode: string): Observable<A3LEmployeeExtraPay[]>{
    return this.get(`${this.getUrl(employeeCode, companyCode)}/extrapayments`);
  }

  getHiringDates(companyCode: string, employeeCode: string): Observable<A3LEmployeeHiringDates>{
    return this.get(`${this.getUrl(employeeCode, companyCode)}/HiringDates`)
  }

  getIdentificationData(companyCode: number, employeeCode: string): Observable<A3LEmployeeIdentificationData>{
    return this.get(`${this.getUrl(employeeCode, companyCode)}/IdentificationData`)
  }

  checkEmployeeCode(companyCode: string, employeeCode: string): Observable<boolean> {
    return this.http.get<boolean>(`${this.getUrl(null, companyCode)}/checkEmployeeCode/${employeeCode}`);
  }

  putCustomData(companyCode: string, request: A3LEmployeeCustomDataUpdateRequest ): Observable<any>{
    return this.http.put(`${this.getUrl(null, companyCode)}/customData`, request);
  }

  putIdentificationData(companyCode: string, codEmpleado: string, request: A3LEmployeeIdentificationDataUpdateRequest) {
    return this.http.put(`${this.getUrl(codEmpleado, companyCode)}/IdentificationData`, request);
  }

  createEmployee(companyCode: string, employee: A3LEmployeeCreateRequest, entityMode: EEntityMode): any{
    return this.http.post<A3LEmployeeCreateRequest>(`${this.getUrl(null, companyCode)}/create-employee?entityMode=${entityMode}`, employee);
  }
}
